import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { Terminal, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Acesso autorizado");
      navigate("/app");
    } catch (err) {
      const msg = formatError(err.response?.data?.detail) || err.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-void px-4">
      <div className="w-full max-w-md fadeup">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <Terminal className="text-acid" size={26} />
          <span className="font-sans font-black text-2xl tracking-tighter">PIPE<span className="text-acid">FORGE</span></span>
        </div>
        <div className="border border-line bg-surface p-8">
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-400 mb-1">Autenticação</div>
          <h1 className="text-3xl font-black tracking-tighter mb-6">Entrar</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-400">Email</label>
              <input
                data-testid="login-email"
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 bg-void border border-line px-3 py-3 text-sm focus:border-acid focus:outline-none focus:ring-1 focus:ring-acid"
                placeholder="admin@pipeforge.dev"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-zinc-400">Senha</label>
              <input
                data-testid="login-password"
                type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-1 bg-void border border-line px-3 py-3 text-sm focus:border-acid focus:outline-none focus:ring-1 focus:ring-acid"
                placeholder="••••••••"
              />
            </div>
            {error && <div data-testid="login-error" className="text-sm text-destructive border border-destructive/40 bg-destructive/10 px-3 py-2">{error}</div>}
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full bg-acid text-black font-bold uppercase tracking-widest text-sm py-3 flex items-center justify-center gap-2 hover:bg-[#32e612] transition-colors disabled:opacity-50"
            >
              {loading ? "Verificando..." : <>Acessar <ArrowRight size={16} /></>}
            </button>
          </form>
        </div>
        <p className="text-center text-sm text-zinc-400 mt-6">
          Não tem conta?{" "}
          <Link to="/register" data-testid="go-register" className="text-acid hover:underline">Criar acesso</Link>
        </p>
      </div>
    </div>
  );
}
